import { DatePicker, Input, Select, Tag } from "antd";
import axiosInstance from "../common/api";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { date2locale } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";
import TablePage from "../components/TablePage";
import { useContext } from "react";
import { UserInfoContext } from "../FetchUserInfo";

export const renderStatus = (status) => {
    const mappedStatus = {
        TO_MANAGE: { color: "warning", value: "Da gestire" },
        MANAGED: { color: "blue", value: "Gestita" },
        CHARGE_CREATED: { color: "green", value: "Addebito creato" },
        ARCHIVED_TO_MANAGE: { color: "", value: "Archiviata" },
        ARCHIVED_MANAGED: { color: "", value: "Archiviata" },
    }[status];
    return mappedStatus && <Tag color={mappedStatus.color}>{mappedStatus.value}</Tag>;
};

const columns = [
    {
        title: "ID",
        dataIndex: "id",
        key: "id",
        width: 100,
        fixed: "left",
        render: (id) => <Link to={"" + id}>{id}</Link>,
    },
    {
        title: "Num. verbale",
        dataIndex: "number",
        width: 150,
        ellipsis: true,
        key: "number",
    },
    {
        title: "Data",
        dataIndex: "date",
        width: 100,
        ellipsis: true,
        key: "date",
        render: (item) => date2locale(item),
    },
    {
        title: "Targa",
        dataIndex: "licensePlate",
        ellipsis: true,
        width: 100,
        key: "licensePlate",
    },
    {
        title: "Descrizione",
        dataIndex: "description",
        key: "description",
        ellipsis: true,
    },
    {
        title: "Assegnato a",
        dataIndex: ["assignedTo", "fullName"],
        width: 200,
        key: "assignedTo",
        ellipsis: true,
    },
    {
        title: "Stato",
        dataIndex: "status",
        width: 150,
        key: "status",
        ellipsis: true,
        render: renderStatus,
    },
];

const filters = [
    {
        name: "number",
        label: "Num. verbale",
        formItem: {
            children: <Input allowClear />,
        },
    },
    {
        name: "licensePlate",
        label: "Targa",
        formItem: {
            children: <Input allowClear />,
        },
    },
    {
        name: "assignedTo",
        label: "Assegnato a",
        readableValue: (value) => JSON.parse(value).label,
        formItem: {
            children: (
                <DebounceSelect
                    fetchOptions={(query) =>
                        axiosInstance
                            .get("user", {
                                params: { query, page: 0, pageSize: 99999 },
                            })
                            .then(({ data }) =>
                                data.data.map((x) => ({
                                    value: x.id,
                                    label: x.firstName + " " + x.lastName,
                                })),
                            )
                    }
                />
            ),
            props: {
                getValueProps: (value) => ({
                    value: value && JSON.parse(value),
                }),
                normalize: (value) => JSON.stringify(value),
            },
        },
    },
    {
        name: "status",
        label: "Stato",
        readableValue: (value) =>
            ({
                TO_MANAGE: "Da gestire",
                MANAGED: "Gestita",
                CHARGE_CREATED: "Addebito creato",
                "ARCHIVED_TO_MANAGE,ARCHIVED_MANAGED": "Archiviata",
            })[value],
        formItem: {
            children: (
                <Select
                    showSearch
                    allowClear
                    options={[
                        { label: "Da gestire", value: "TO_MANAGE" },
                        { label: "Gestita", value: "MANAGED" },
                        { label: "Addebito creato", value: "CHARGE_CREATED" },
                        {
                            label: "Archiviata",
                            value: "ARCHIVED_TO_MANAGE,ARCHIVED_MANAGED",
                        },
                    ]}
                />
            ),
        },
    },
    {
        name: "date",
        label: "Data",
        readableValue: (value) =>
            `Dal ${date2locale(value.split("_")[0])} al ${date2locale(value.split("_")[1])}`,
        formItem: {
            children: <DatePicker.RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />,
            props: {
                getValueProps: (value) => ({
                    value: value ? [dayjs(value.split("_")[0]), dayjs(value.split("_")[1])] : [],
                }),
                normalize: (value) =>
                    value.length === 2 &&
                    value[0].format("YYYY-MM-DD") + "_" + value[1].format("YYYY-MM-DD"),
            },
        },
    },
];

export default function () {
    const navigate = useNavigate();
    const userInfo = useContext(UserInfoContext);

    const fetchFunction = (params) => {
        if (params.date) {
            params.startDate = params.date.split("_")[0];
            params.endDate = params.date.split("_")[1];
            delete params.date;
        }
        if (params.status) params.status = params.status.split(",");
        if (params.assignedTo) params.assignedTo = JSON.parse(params.assignedTo).value;

        return axiosInstance.get("fine", {
            params,
            paramsSerializer: { indexes: null },
        });
    };

    return (
        <TablePage
            columns={columns}
            fetchFunction={fetchFunction}
            filterItems={filters}
            toolbarProps={{
                addAction: userInfo.permissions?.includes("fine.create")
                    ? () => navigate("new")
                    : null,
            }}
            enableSelection={false}
        />
    );
}
